import Box from 'components/Box';
import { IStaffPayrollPrintData } from 'features/report/services/types/reportStaff';
import { sumBy } from 'lodash';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { ReportPayrollCaption2HighLightRow, ReportPayrollCaption2Row, ReportPayrollTitleRow } from './components';
import Text from 'components/Text';
import { useMemo } from 'react';
type StaffHistoryTimeClocksProps = {
  data?: IStaffPayrollPrintData['historyTimeClocks'];
  tip?: number;
  totalPaidOut?: number;
  staffName?: string;
  className?: string;
  regularHours?: number;
  regularPayAmount?: number;
  overtimeHours?: number;
  overtimePayAmount?: number;
  yearly?: boolean;
  hideTimeClocks?: boolean;
};
const StaffHistoryTimeClocks = ({ hideTimeClocks, yearly, data, tip, totalPaidOut, staffName, className, regularHours, regularPayAmount, overtimeHours = 0, overtimePayAmount = 0 }: StaffHistoryTimeClocksProps) => {
  const totalHours = useMemo(() => sumBy(data, o => o.hourly), [data]);

  const SummaryView = () => (
    <Box>
      <ReportPayrollCaption2Row style={{ padding: 0 }} label='Total Hours' amount={`${totalHours.toFixed(2)} hours`} />
      <ReportPayrollCaption2Row style={{ padding: 0 }} label='Tips' amount={formatCurrency(tip)} />
      <ReportPayrollCaption2Row style={{ padding: 0 }} label='Regular Hours' amount={`${formatCurrency(regularHours)} hours`} />
      <ReportPayrollCaption2Row style={{ padding: 0 }} label='Regular Pay Out' amount={formatCurrency(regularPayAmount)} />
      {overtimeHours > 0 ? <ReportPayrollCaption2Row style={{ padding: 0 }} label='Overtime Hours' amount={`${formatCurrency(overtimeHours)} hours`} /> : null}
      {overtimePayAmount > 0 ? <ReportPayrollCaption2Row style={{ padding: 0 }} label='Overtime Pay Out' amount={formatCurrency(overtimePayAmount)} /> : null}
      <ReportPayrollCaption2HighLightRow label='HOURLY PAY OUT' amount={formatCurrency(totalPaidOut)} />
    </Box>
  );

  if (yearly) {
    return (
      <StaffHistoryTimeClocksContainer className={className}>
        <SummaryView />
      </StaffHistoryTimeClocksContainer>
    );
  }

  if (!data?.length) return null;


  return (
    <StaffHistoryTimeClocksContainer className={className}>
      <SummaryView />
      {!hideTimeClocks && <StaffHistoryTimeClocksTableStyled className='StaffHistoryTimeClocksTableStyled'>
        <thead>
          <tr>
            <th style={{ textAlign: 'start' }}>DATE</th>
            <th style={{ textAlign: 'end' }}>CLOCK IN</th>
            <th style={{ textAlign: 'end' }}>CLOCK OUT</th>
            <th style={{ textAlign: 'end' }}>HOURS</th>
            <th style={{ textAlign: 'end' }}>PAY OUT</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, i) => (
            <tr key={i}>
              <td style={{ textAlign: 'start' }}>{item.date}</td>
              <td style={{ textAlign: 'end' }}>{item.clockInTime}</td>
              <td style={{ textAlign: 'end' }}>{item.clockOutTime}</td>
              <td style={{ textAlign: 'end' }}>{item.hourly}</td>
              <td style={{ textAlign: 'end' }}>{formatCurrency(item.paidOut)}</td>
            </tr>
          ))}
        </tbody>
      </StaffHistoryTimeClocksTableStyled>}
    </StaffHistoryTimeClocksContainer>
  );
};

export default StaffHistoryTimeClocks;

const StaffHistoryTimeClocksContainer = styled(Box)`

`;

const StaffHistoryTimeClocksTableStyled = styled.table`
  width: 100%;
  border-top: 1px solid black;
  thead {
    th {
      color: black;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      border-bottom: 1px dashed black;
    }
  }
  tbody {
    td {
      font-family: 'Roboto', serif !important;
      color: black;
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      vertical-align: unset;
    }
    .highlight {
      font-size: 0.8125rem;
      font-style: normal;
      font-weight: 600;
      line-height: 150%;
    }
  }
`;